import React from "react";

import { Event } from "@mui/icons-material";
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, FormGroup, Stack, TextField, TextareaAutosize, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Service from "../../../util/Service";
import { formataData } from "../../../util/Utilitarios";

export default function KanbanNovoEvento(props) {
    const { kanban, action, close } = props;
    const [open, setOpen] = React.useState(false);
    const [dt, setDt] = React.useState();
    const [notifica, setNotifica] = React.useState(true);
    const [txt, setTxt] = React.useState('');
    const [nome, setNome] = React.useState(kanban?kanban.nome:'');
    const [pagina, setPagina] = React.useState('');
    const [showRet, setShowRet]= React.useState(false);
    const [titulo, setTitulo] = React.useState('Definição do evento');
    
    const [msg, setMsg] = React.useState({
        error: false,
        txt:''
    });

    // React.useEffect(() => {
    //     if (kanban) {
    //         console.log(kanban);
    //     }
    // }, [kanban]);

    const handleClose = () => {
        setOpen(false);
        handleSair();
    };
    const handleChangeDate = (e) => {        
        setDt(new Date(e) );
    }
    const handleSubmit=()=>{
        if( !dt){
            setMsg({
                error: true,
                txt: 'Data do evento é obrigatório!'
            });
            return;
        }
        setMsg({
            error: false,
            txt: ''
        });
        const dado = {
            dt: dt.getTime(),
            notifica: notifica,
            nome: nome,
            msg: txt,
            pagina: pagina,
            source: {
                idKanban: kanban.id,
                idProjeto: kanban.idProjeto
            },
            publicoAlvo: kanban.membros
        }
        Service.POST('/api/projeto/kanban/evento', dado).then( r =>{
            if( r.success){
                setTitulo("Evento definido "+ formataData(dt) );
                setShowRet(true);
            }else{
                alert(r.msg)
            }
        })
    }
    const ResultEvento=()=>{
        if( !showRet) return;
        return (
            <Stack  spacing={2}>
                <DialogContentText >
                    {txt}
                </DialogContentText>    
                <Stack direction="row" spacing={2}>
                    {notifica === true &&
                        <Typography>Todos os membros serão notificados</Typography>
                    }                    
                </Stack>
            </Stack>
        )
    }
    const FormEvento=()=>{
        if( showRet) return;
        return (
            <Stack  spacing={2}>
                <DialogContentText style={{fontSize: "0.8rem", textAlign: "center" }}>
                    Evento para marcar uma data cerimonial como entrega de sprint, revisão de sprint, novo planejamento ou qualquer marco relevante para o quadro de atividades do projeto.
                </DialogContentText>    
                <Stack direction="row" spacing={2}>
                    <DatePicker
                        label="Data do evento"
                        slotProps={{ textField: { 
                            size: 'small',
                            helperText: msg.txt,
                            error: msg.error, // Set to true to show error state
                            autoFocus: true
                        } }}
                        size="samll"
                        isRequired={true}
                        format="DD/MM/YYYY"
                        onChange={handleChangeDate}
                    />
                    <FormGroup>
                        <FormControlLabel control={<Checkbox defaultChecked />} label="Notificar os envolvidos" />                            
                    </FormGroup>
                </Stack>
                <Stack direction="row" spacing={2}>
                    <TextField label="Nome"   size='small' variant="outlined" value={nome} onChange={e =>setNome(e.target.value)}/>
                    <TextField label="Pagina" size='small' variant="outlined" 
                        value={pagina} onChange={e =>setPagina(e.target.value)}
                        helperText="Pagina de ação do evento"
                    />
                </Stack>
                <Typography>Descrição do evento:</Typography>
                <TextareaAutosize
                    maxRows={4}
                    aria-label="maximum height"
                    placeholder="Maximum 4 rows"                            
                    style={{ width: "100%", height:65 }}
                    value={txt}
                    onChange={(e)=>setTxt(e.target.value)}
                />
            </Stack>
        )
    }
    const handleOpenDialog=()=>{
        close();
        setOpen(true)
    }
    function handleSair(){
        setOpen(false);
        setTimeout(() => {
            setTitulo('Definição do evento');
            setShowRet(false);    
            setNome('');
            setTxt('');
            setPagina('');
        }, 300);
    }
    return (
        <React.Fragment>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Button startIcon={<Event />} size='small'
                    onClick={handleOpenDialog}
                >
                    Novo Evento
                </Button>

                <Dialog
                    open={open}
                    onClose={handleClose}
                    // disableRestoreFocus
                    disableEnforceFocus
                >
                    <DialogTitle id="alert-dialog-title">
                        {titulo}
                    </DialogTitle>
                    <DialogContent>
                       {/* <FormEvento/> */}
                       {FormEvento()}
                       <ResultEvento />
                    </DialogContent>
                    
                    <DialogActions>
                        {!showRet &&
                        <React.Fragment>
                            <Button onClick={()=>setOpen(false)}>Cancelar</Button>
                            <Button autoFocus onClick={handleSubmit}>
                                Criar Evento
                            </Button>    
                        </React.Fragment>
                        }
                        {showRet &&
                            <Button onClick={handleSair}>Sair</Button>
                        }
                    </DialogActions>
                </Dialog>
            </LocalizationProvider>            
        </React.Fragment>
    )
}